import Text from 'components/Text/Text';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import style from './AssignmentBtn.module.scss';

const AssignmentBtn: React.FC = () => {
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	return (
		<Link to={`/app/tablet-app${hasAccess ? '/assignment' : ''}`} data-test="AssignmentBtn">
			<Button
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#list`} />
					</svg>
				}
				disabled={!hasAccess}>
				<Text translationNameSpace="listing" translationKey="assignmentButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default AssignmentBtn;
